/* tslint:disable */
/* eslint-disable */
/**
 * Optimizely Feature Experimentation API
 * This page documents how to use the Optimizely FX API. With this API you can view and manage Feature Flags and all of their related entities including Variables, Variations, Rules, and Reports.  The base URL is https://api.optimizely.com/flags/v1. Append any paths listed in these docs onto that url in order to make requests to the API.
 *
 * The version of the OpenAPI document: 0.3.7
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Flag,
    FlagFromJSON,
    FlagFromJSONTyped,
    FlagToJSON,
    UrlList,
    UrlListFromJSON,
    UrlListFromJSONTyped,
    UrlListToJSON,
} from './';

/**
 * 
 * @export
 * @interface Flags
 */
export interface Flags {
    /**
     * 
     * @type {Array<Flag>}
     * @memberof Flags
     */
    items: Array<Flag>;
    /**
     * Number of Flags on the current page.
     * @type {number}
     * @memberof Flags
     */
    count: number;
    /**
     * Number of the current page. 1-index based.
     * @type {number}
     * @memberof Flags
     */
    page: number;
    /**
     * Total number of Flags for this series.
     * @type {number}
     * @memberof Flags
     */
    total_count: number;
    /**
     * Total number of pages for this series.
     * @type {number}
     * @memberof Flags
     */
    total_pages: number;
    /**
     * Link to self
     * @type {string}
     * @memberof Flags
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof Flags
     */
    create_url?: string;
    /**
     * Url template like \'.../{?filter}\'
     * @type {string}
     * @memberof Flags
     */
    filter_url?: string;
    /**
     * Url template like \'.../{?sort}\'
     * @type {string}
     * @memberof Flags
     */
    sort_url?: string;
    /**
     * Link to first page of Flags in a series.
     * @type {string}
     * @memberof Flags
     */
    first_url: string;
    /**
     * Link to the last page of Flags in a series.
     * @type {string}
     * @memberof Flags
     */
    last_url: string;
    /**
     * List of links to next pages of Flags in a series.   The first element in the array is the exact next page after the current record, etc. 
     * @type {UrlList}
     * @memberof Flags
     */
    next_url?: UrlList;
    /**
     * List of links to previous pages of Flags in a series.  The first element in the array is the exact previous page before the current record, etc. 
     * @type {UrlList}
     * @memberof Flags
     */
    prev_url?: UrlList;
    /**
     * Link to the default pages of Flags
     * @type {string}
     * @memberof Flags
     */
    reset_url?: string;
    /**
     * A url template to be used to find a particular Flag. 
     * @type {string}
     * @memberof Flags
     */
    fetch_flag_url?: string;
}

export function FlagsFromJSON(json: any): Flags {
    return FlagsFromJSONTyped(json, false);
}

export function FlagsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Flags {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(FlagFromJSON)),
        'count': json['count'],
        'page': json['page'],
        'total_count': json['total_count'],
        'total_pages': json['total_pages'],
        'url': json['url'],
        'create_url': !exists(json, 'create_url') ? undefined : json['create_url'],
        'filter_url': !exists(json, 'filter_url') ? undefined : json['filter_url'],
        'sort_url': !exists(json, 'sort_url') ? undefined : json['sort_url'],
        'first_url': json['first_url'],
        'last_url': json['last_url'],
        'next_url': !exists(json, 'next_url') ? undefined : UrlListFromJSON(json['next_url']),
        'prev_url': !exists(json, 'prev_url') ? undefined : UrlListFromJSON(json['prev_url']),
        'reset_url': !exists(json, 'reset_url') ? undefined : json['reset_url'],
        'fetch_flag_url': !exists(json, 'fetch_flag_url') ? undefined : json['fetch_flag_url'],
    };
}

export function FlagsToJSON(value?: Flags | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(FlagToJSON)),
        'count': value.count,
        'page': value.page,
        'total_count': value.total_count,
        'total_pages': value.total_pages,
        'url': value.url,
        'create_url': value.create_url,
        'filter_url': value.filter_url,
        'sort_url': value.sort_url,
        'first_url': value.first_url,
        'last_url': value.last_url,
        'next_url': UrlListToJSON(value.next_url),
        'prev_url': UrlListToJSON(value.prev_url),
        'reset_url': value.reset_url,
        'fetch_flag_url': value.fetch_flag_url,
    };
}


